module.exports = __webpack_public_path__ + "static/media/plusIcon.b61973e3.svg";